import Cache from 'root/cache';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    className: 'bookmark',

    duration: 0,

    events: {
        'click': 'onClick'
    },

    dom_handlers: {
        onClick: function(e) {
            this.trigger('open', this.model);
            this.dispatcher.trigger('Pin_Comment:Open', this.model.id);
        }
    },

    open: function() {
        this.$el.click();
    },

    initialize: function(options) {
        this.duration   = options.duration;
        this.feedback   = options.feedback;
        this.dispatcher = options.dispatcher;

        this.listenTo(this.model, 'change', this.render);
    },

    updateResolvedStatus: function() {
        if (this.model.get('is_resolved'))  {
            this.$el.attr('resolved', 'true');
        } else {
            this.$el.removeAttr('resolved');
        }
    },

    getDisplayTime: function() {
        var seconds = Math.round(this.model.get('video_time'));

        var hour = Math.floor(seconds / 3600);
        var min  = Math.floor((seconds - hour * 3600) / 60);
        var sec  = seconds - hour * 3600 - min * 60;

        if (min < 10) {
            min = '0' + min;
        }

        if (sec < 10) {
            sec = '0' + sec;
        }

        return (hour ? hour + ':' : '') + min + ':' + sec;
    },

    render: function(options) {
        var user           = Cache.user.get(this.model.get('user_id'));
        var gravatar_email = user ? user.get('email') : this.model.get('anon_email');
        var gravatar_name  = user ? user.get('name') : this.model.get('anon_name');
        var avatar_tooltip = Util.htmlEntities(gravatar_name) + ' (' + this.getDisplayTime() + ')';

        var content = '';

        if (user) {
            content += '<img class="bookmark-avatar tooltip" data-title="' + avatar_tooltip + '" src="' + user.getAvatar(24) + '">';
        } else {
            content += '<img class="bookmark-avatar tooltip" data-title="' + avatar_tooltip + '" src="' + Util.gravatar(gravatar_email, 24) + '">';
        }

        this.updateResolvedStatus();
        this.$el.html(content);

        this.$el.css('left', this.model.get('video_time') / this.duration * 100 + '%');

        return this;
    }
});